import React from "react"
import { cond, T } from "ramda"
import { withAuthProvider } from "../../../lib/auth"
import QuickLinks from "../QuickLinks"
import { Side } from "../Panel"
import { NewMSRCreditsBrief, NewCompactPDRBrief } from "../PDRCredits"
import {
  isMember,
  isAssociate,
  isAffiliate,
  isPendingAssociate,
  isPendingAffiliate,
  isAffiliateToAssociatePending,
  isStudent,
  hasReciprocityAttribute,
  hasStartedReciprocityLevels,
  isB25Class,
  hasProspectDashboard,
  isProspectPath,
} from "../../utils"
import { Loading } from "../CourseCurriculum/CourseCurriculum"
import CourseCurriculum from "../CourseCurriculum"
import PathBox from "../Prospect/PathBox"
import { withProspectDateQuery } from "../../../utils/prospect/withProspectDateQuery"
import { useMembershipJourney } from "../../../hooks/useMembershipJourney"
import { MembershipJourneyProvider } from "../MembershipJourney/MembershipJourneyContext"

const CourseCurriculumBriefing = ({ collapsed, person }) =>
  collapsed ? (
    <div />
  ) : (
    <MembershipJourneyProvider
      value={{
        me: person,
        pgaId: person?.pgaId,
        pgmProgress: person?.pgmProgress,
      }}
    >
      <CourseCurriculum />
    </MembershipJourneyProvider>
  )

const PdrWidget = ({ collapsed }) => {
  return collapsed ? <NewCompactPDRBrief /> : <NewMSRCreditsBrief />
}

export const chooseAppropriateViewForUser = cond([
  [({ loading }) => loading, () => <Loading />],
  [({ routingMe }) => isMember(routingMe), PdrWidget],
  [({ routingMe }) => isB25Class(routingMe), PdrWidget],
  [({ routingMe }) => isAssociate(routingMe), CourseCurriculumBriefing],
  // Registered Affiliates may have mainProgramTypeCode AF (Coach Tools), which
  // isAssociate does not match — keep Course Curriculum for that shape.
  [({ routingMe }) => isAffiliate(routingMe), CourseCurriculumBriefing],
  [
    ({ routingMe }) => isAffiliateToAssociatePending(routingMe),
    CourseCurriculumBriefing,
  ],
  [
    ({ routingMe }) => isPendingAssociate(routingMe),
    ({ collapsed }) => <QuickLinks collapsed={collapsed} />,
  ],
  [({ routingMe }) => isStudent(routingMe), CourseCurriculumBriefing],
  // Only show Reciprocity if they have started Z-levels, otherwise let prospects see PathBox
  [
    ({ routingMe }) =>
      hasReciprocityAttribute(routingMe) &&
      hasStartedReciprocityLevels(routingMe),
    CourseCurriculumBriefing,
  ],
  [
    ({ routingMe, currentMember }) =>
      hasProspectDashboard(routingMe) ||
      isPendingAffiliate(routingMe) ||
      isProspectPath(currentMember),
    ({ collapsed }) => (collapsed ? <div /> : <PathBox />),
  ],
  [T, ({ collapsed }) => <QuickLinks collapsed={collapsed} />],
])

export const MembershipSailingView = ({
  me,
  authReady,
  collapsed,
  currentMember,
}) => {
  const { person, loading: personLoading } = useMembershipJourney()
  const routingMe = person || me

  return (
    <Side basis={!collapsed && 55}>
      {chooseAppropriateViewForUser({
        me,
        person: routingMe,
        routingMe,
        loading: !authReady || personLoading,
        collapsed,
        currentMember,
      })}
    </Side>
  )
}

export default withProspectDateQuery(withAuthProvider(MembershipSailingView))
